import { render, staticRenderFns } from "./Pen.vue?vue&type=template&id=321b03a7&scoped=true"
var script = {}
import style0 from "./Pen.vue?vue&type=style&index=0&id=321b03a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b03a7",
  null
  
)

export default component.exports